import { IIssueBoardApi } from "@mcapps/shared";
import { ColDef } from "ag-grid-community";
import * as R from "ramda";
import { ISSUE_SECTIONS } from "../../../issueConstants";

export const buildIssueColumnGroups = ({
  columns,
  columnsVisibility,
  issueBoard,
  otherAttributeColumns,
}: {
  columns: ColDef<any>[];
  columnsVisibility: string[];
  issueBoard: IIssueBoardApi;
  otherAttributeColumns: ColDef<any>[];
}): ColDef<any>[] => {
  const visibleColumns = columns.map((col) => ({
    ...col,
    hide: col.context === ISSUE_SECTIONS.METACOLUMN ? col.hide : !columnsVisibility.includes(col.field),
  }));

  const initialColumns = [
    {
      headerName: "",
      children: [...visibleColumns.filter((col) => col.context === ISSUE_SECTIONS.METACOLUMN)],
      suppressColumnsToolPanel: true,
    },
    {
      headerName: ISSUE_SECTIONS.COMMON,
      children: [...visibleColumns.filter((col) => col?.context === undefined && col.headerName.length > 0)],
    },
    {
      headerName: ISSUE_SECTIONS.TIME,
      children: [...visibleColumns.filter((col) => col?.context === ISSUE_SECTIONS.TIME)],
    },
    {
      headerName: ISSUE_SECTIONS.DATES,
      children: [...visibleColumns.filter((col) => col?.context === ISSUE_SECTIONS.DATES)],
    },
    {
      headerName: ISSUE_SECTIONS.HISTORY,
      children: [...visibleColumns.filter((col) => col?.context === ISSUE_SECTIONS.HISTORY)],
    },
    ...(issueBoard?.risikoSection?.isActive === true
      ? [
          {
            headerName: ISSUE_SECTIONS.RISIKO,
            children: [...visibleColumns.filter((col) => col?.context === ISSUE_SECTIONS.RISIKO)],
          },
        ]
      : []),
  ];

  const groupedByType = R.groupBy((colDef) => colDef.context.toString(), otherAttributeColumns);
  const otherAttributeColumnGroups = Object.entries(groupedByType).map(([type, cols]) => ({
    headerName: type,
    children: cols,
  }));

  return [...initialColumns, ...otherAttributeColumnGroups];
};
